export default __webpack_public_path__ + "static/media/flask.c9d4b00a.png";